<template>
	<div ref="el" class="c-form-checkbox">
		<!-- Checkbox input -->
		<label
			class="group inline-flex items-center pointer-events-auto cursor-pointer"
		>
			<input
				type="checkbox"
				:name="name"
				:value="value"
				:checked="checked"
				:required="required"
				class="c-form-checkbox__input flex-shrink-0"
				@change="onChange"
			/>
			<span v-if="label" class="ml-layout-gutter">
				{{ label }}
				<BaseDialog
					v-if="description"
					v-slot="{ toggle }"
					title="Info"
					:text="description"
				>
					<button
						class="ml-[4px] w-[13px] h-[13px] flex-shrink-0 text-orange align-baseline transform translate-y-[2px]"
						@click="toggle(true)"
					>
						<SvgIconInfo />
					</button>
				</BaseDialog>
			</span>
		</label>
	</div>
</template>

<script setup>
import SvgIconInfo from '~/assets/svgs/icon-info.svg';

const el = ref(null);
const emit = defineEmits(['update:checked']);
const props = defineProps({
	label: String,
	description: String,
	name: String,
	value: String,
	checked: Boolean,
	required: Boolean,
});
const checked = ref(props.checked);
const required = ref(props.required);

const onChange = (event) => {
	checked.value = event.target.checked;
};

watch(
	() => props.checked,
	(newValue) => {
		checked.value = newValue;
	}
);
watch(
	() => checked.value,
	(newValue) => {
		emit('update:checked', newValue);
	}
);
</script>

<style lang="postcss">
.c-form-checkbox__input {
	@apply appearance-none relative w-[14px] h-[14px] border-2 border-text group-hover:border-orange;

	&:checked:before {
		content: '';
		@apply absolute inset-[1px] bg-text group-hover:bg-orange;
		clip-path: polygon(
			20% 0%,
			0% 20%,
			30% 50%,
			0% 80%,
			20% 100%,
			50% 70%,
			80% 100%,
			100% 80%,
			70% 50%,
			100% 20%,
			80% 0%,
			50% 30%
		);
	}
}
.c-form-checkbox__input:has(button:hover) {
	@apply group-hover:border-text;

	&:checked:before {
		@apply group-hover:bg-text;
	}
}
</style>
